import script from "./HeartAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./HeartAnimation.vue?vue&type=script&setup=true&lang=js"

import "./HeartAnimation.vue?vue&type=style&index=0&id=2f38f04e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f38f04e"]])

export default __exports__